import styled from 'styled-components'

import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18n-lite'

import { AutocompleteUniselection } from '@yes.technology/react-toolkit'

import { useSectionFilteraction } from '../Section/SectionContext'
import { useSiteState } from 'siteState/shared'

const Container = styled.div`
  width: 100%;
`

const FilteractionSelection = () => {
  const { t } = useTranslation()
  const {
    filteractionValue: value,
    setFilteractionValue: setValue,
    filteractions,
    onSelectFilteraction
  } = useSectionFilteraction()

  const [, setFilteractionName] = useSiteState<string>('filteraction-name')
  const [resetKey, setResetKey] = useState(0)
  const previousValueRef = useRef(value)

  useEffect(() => {
    if (previousValueRef.current && !value) {
      setResetKey((previous) => previous + 1)
    }

    previousValueRef.current = value
  }, [value])

  const sortedFilteractions = filteractions.sort(
    (a, b) => parseInt(a.complement) - parseInt(b.complement)
  )

  const options = sortedFilteractions.map(({ uuid, des }) => ({
    id: uuid,
    value: des
  }))

  const onChange = (newValue: string | { des: string; uuid: string }) => {
    const newValueString =
      typeof newValue === 'string' ? newValue : newValue.des

    setFilteractionName(newValueString)

    setValue(newValueString)

    onSelectFilteraction(
      filteractions.find((filteraction) => filteraction.des === newValueString)
    )
  }

  return (
    <Container>
      <AutocompleteUniselection
        key={resetKey}
        label={t('filteraction-selection.label')}
        statusClass={value ? 'valid' : 'default'}
        {...{ value, options, onChange }}
      />
    </Container>
  )
}

export default FilteractionSelection
